import { useRef } from 'react';
import styles from './FileUpload.module.css';
import { StyleProps } from './types';

export type FileUploadProps = StyleProps & {
	label?: string;
	compact?: boolean;
	frameless?: boolean;
	accept?: string;
	multiple?: boolean;
	disabled?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	resetOnSelect?: boolean; // clears input value after selection to allow re-selecting same file
};

const FileUpload = ({
	label,
	compact,
	frameless,
	accept,
	multiple,
	disabled,
	onChange,
	className,
	style,
	resetOnSelect = true,
}: FileUploadProps) =>
{
	const inputRef = useRef<HTMLInputElement>(null);

	const handleClick = () =>
	{
		if (!disabled) inputRef.current?.click();
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		onChange?.(event);
		if (resetOnSelect)
		{
			// Allow selecting the same file again after handling upload
			event.target.value = '';
		}
	};

	return (
		<>
			<input
				ref={inputRef}
				type="file"
				accept={accept}
				multiple={multiple}
				onChange={handleChange}
				disabled={disabled}
				style={{ display: 'none' }}
			/>
			<button
				type="button"
				className={`${styles.fileInput}${compact ? ` ${styles.compact}` : ''}${frameless ? ` ${styles.frameless}` : ''}${className ? ` ${className}` : ''}${label ? ` ${styles.compactRight}` : ''}`}
				style={style}
				disabled={disabled}
				onClick={handleClick}
			>
				{label}
			</button>
		</>
	);
};

export default FileUpload;
